import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getUsersList() {
    try {
        const res = await axios.get('/admin-dashboard/users');
        // console.log('res....', res);
        return res.data?.data;
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}